
export const UI_SHOW_TOAST = '[UI] Show toast'
export const showToast = (message, type = 'info', config = {}) => ({type: UI_SHOW_TOAST, payload: {message, type, config}})
